module.exports = __webpack_public_path__ + "static/media/route-interstate.111d8f63.svg";